import { useEffect, useState } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import axios from 'axios';

const TurnstileWidget = ({ setTurnstileTokenStatus }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [turnstileToken, setTurnstileToken] = useState('');

    useEffect(() => {
        const verifyTurnstileToken = async () => {
            if (turnstileToken !== '') {
                try {
                    const response = await axios.post(`${baseURL}/api/users/verifyTurnstileToken`, { turnstileToken });
                    const result = response.data;
                    /*if (result.outcome.success) {
                        console.log('You are a human.');
                    } else {
                        console.log('You are a bot.');
                    }*/
                } catch (error) {
                    //console.error('Verification error:', error);
                }
            }
        };

        verifyTurnstileToken();
    }, [turnstileToken]);

    return (
        <Turnstile
            siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
            onError={() => setTurnstileTokenStatus('error')}
            onExpire={() => setTurnstileTokenStatus('expired')}
            onSuccess={(token) => {
                setTurnstileToken(token);
                setTurnstileTokenStatus('solved');
            }}
            //onWidgetLoad={(widgetId) => console.log('Widget loaded', widgetId)}
        />
    );
};

export default TurnstileWidget;